/* eslint-disable ember/no-classic-components */
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

@tagName('')
export default class ReportPanel extends Component {
  label = null;
  number = null;
  isComplete = false;
}
